module.exports = __webpack_public_path__ + "5142ad86578d98d91cb92de8e4cb53f7.png";